<style lang="less" scoped>
  .abs-center { position: absolute; left: 50%; top: 50%; transform: translate(-50%,-50%); }
  .abs-lcenter { position: absolute; left: 50%; transform: translate(-50%,0); }
  .media {
    position: absolute; bottom: 0; z-index: 10;
    width: 270px; height: 450px; background-color: #fff;
    box-shadow: 0 10px 46px rgba(0, 0, 0, .01);
    img.thumb {
      width: 100%; height: 100%;
    }
    &::before {
      content: ''; position: absolute; left: 0; top: -55px; width: 100%; height: 55px;
      background-color: #9b9fa5; border-radius: 40px 40px 0 0;
    }
    &::after {
      content: ''; width: 52px; height: 4px; background-color: #878d96;
      .abs-lcenter; top: -28px; border-radius: 2px;
    }
    a.play {
      width: 80px; height: 80px; background-color: #7f7f7f; border-radius: 100%;
      .abs-center;
      &:after {
        content: ''; width: 28px; height: 36px; display: block; .abs-center;
        background: url('~@/assets/btn-play-1.png') no-repeat;
        margin-left: 5px;
      }
    }
    &.left {
      left: 0;
    }
    &.right {
      right: 0;
    }
  }

  .youtube {
    position: fixed; left: 0; top: 0; right: 0; bottom: 0; z-index: 100;
    &::after {
      content: ''; display: block; position: fixed; left: 0; top: 0; right: 0; bottom: 0; background-color: #000;
      opacity: .2; z-index: 1;
    }
    .sec {
      .abs-center; z-index: 101; display: inline-block;
      width: 1280px; height: 720px;
    }
  }

  @media only screen and (max-width: 1280px) {
    .youtube {
      .sec {
        width: 1000px; height: 563px;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .media {
      width: 150px; height: 250px; margin: 0 10px;
      &::before {
        height: 30px; top: -30px; border-radius: 25px 25px 0 0;
      }
      &::after {
        height: 2px; top: -15px;
      }
      a.play {
        width: 35px; height: 35px;
        &::after {
          width: 14px; height: 18px;
          background-size: cover; margin-left: 2px;
        }
      }
    }
    .youtube {
      .sec {
        width: 100%; height: 432px;
      }
    }
  }
</style>

<template lang="pug">
  .media-container(v-if="visible")
    .media(:class="align")
      div(v-if="mediaData.type === 'movie'")
        img.thumb(:src="mediaData.data.thumbnail")
        a.play(@click="youtubeShow")
      swiper(v-if="mediaData.type === 'photo'" :options="swiperOption")
        swiper-slide(v-for="(item, index) in mediaData.data", :key="index")
          img.thumb(:src="item")
        div.swiper-pagination(slot="pagination")
    .youtube(v-if="youtubeVisible", @click="youtubeHide")
      .sec
        youtube(:video-id="videoId", ref="youtube", width="100%", height="100%")
</template>

<script>
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
  props: {
    align: {
      type: String,
      default: 'left',
    },
    visible: {
      type: Boolean,
      default: true,
    },
    mediaData: {
      type: Object,
      default: null,
    },
  },
  components: {
    swiper,
    swiperSlide,
  },
  methods: {
    youtubeShow() {
      this.youtubeVisible = true;
    },
    youtubeHide() {
      this.youtubeVisible = false;
    },
  },
  mounted() {
    if (this.mediaData.type === 'movie') {
      this.videoId = this.mediaData.data.youtube;
    }
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
      youtubeVisible: false,
      videoId: null,
    };
  },
};
</script>
